const o = ({
  filters: t,
  persistentFilterKeysOnReset: n
}) => n.reduce((r, e) => (t[e] && (r[e] = t[e]), r), {});
export {
  o as getFiltersOnReset
};
